import { motion } from "framer-motion";

const ease = [0.22, 0.61, 0.36, 1];

/**
 * Animated monospace section label.
 * Usage: <SectionLabel className="mb-6">[ 01 ] - POSITIONING</SectionLabel>
 *
 * Animation (all triggered on viewport entry):
 *   1. A small dark-purple square pulses to the left of the label.
 *   2. Characters reveal left-to-right with a tight stagger.
 *   3. A thin dark-purple underline draws in beneath.
 */
const SectionLabel = ({ children, className = "", testid }) => {
  const text = String(children ?? "");
  return (
    <motion.div
      initial={{ opacity: 0, x: -8 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease }}
      className={`inline-block ${className}`}
      data-testid={testid}
    >
      <div className="mono-label relative inline-flex items-center pb-1.5">
        <motion.span
          initial={{ opacity: 0, scale: 0 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.45, delay: 0.1, ease }}
          className="uprcse-pulse-dot mr-3 inline-block w-1.5 h-1.5 bg-[#AE519F]"
          aria-hidden
        />

        <span className="inline-flex flex-wrap">
          {text.split("").map((ch, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, y: 4 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.28, delay: 0.22 + i * 0.012, ease }}
              className="inline-block whitespace-pre"
            >
              {ch === " " ? "\u00A0" : ch}
            </motion.span>
          ))}
        </span>

        <motion.span
          className="absolute left-0 bottom-0 h-px bg-black origin-left"
          style={{ width: "100%" }}
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.32, ease }}
          aria-hidden
        />
      </div>
    </motion.div>
  );
};

export default SectionLabel;
